import { render, staticRenderFns } from "./edit-accident-details-modal.vue?vue&type=template&id=7ee8c723&scoped=true&"
import script from "./edit-accident-details-modal.vue?vue&type=script&lang=js&"
export * from "./edit-accident-details-modal.vue?vue&type=script&lang=js&"
import style0 from "./edit-accident-details-modal.vue?vue&type=style&index=0&id=7ee8c723&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee8c723",
  null
  
)

export default component.exports